import React, { useCallback, useEffect, useState } from "react";
import PageContainer from "../components/PageContainer";
import { getAboutAbout } from "../api/about";
import { toImagePath } from "../utils/globalFunctions";
import Slider from "react-slick";
import { Tooltip } from "flowbite-react";

const bgImg = "/images/hero-image.jpeg";

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  autoplay: true,

  slidesToShow: 1,
  slidesToScroll: 1,
};

function About() {
  const [pageData, setPageData] = useState(null);

  const getData = useCallback(
    () =>
      getAboutAbout()
        .then((res) => setPageData(res))
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <PageContainer
      title={pageData?.title}
      bgImg={toImagePath(pageData?.Image?.topimage?.path) ?? bgImg}
    >
      <section>
        <div className="container mx-auto mt-[-50px] max-w-[1200px]">
          <div className={`card bg-white shadow-xl mx-auto`}>
            <div className="card-body min-h-[800px]">
              <div>
                <Slider {...settings}>
                  {pageData?.topimage?.map((img) => {
                    return (
                      <div className="w-full">
                        <Tooltip content={img?.description}>
                          <img
                            className="img-aspect-video"
                            src={toImagePath(img?.path)}
                            alt={img?.title}
                          />
                        </Tooltip>
                      </div>
                    );
                  })}
                </Slider>
                <div className="md:px-12">
                  <p className="text-md text-[#3D3D3D] font-medium py-6 px-4">
                    <div
                      className="dangerous-html-content"
                      dangerouslySetInnerHTML={{ __html: pageData?.content }}
                    />
                  </p>
                </div>
                {/* <div className="news-card__slug-footer"></div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
}

export default About;
